'use strict';

// theme getter
var _require = require('./util'),
    get = _require.get;

module.exports = function (keys, fallback) {
  return function (props) {
    return get(props.theme, keys, fallback);
  };
};


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/styled-system/dist/theme.js
// module id = 4374
// module chunks = 168707334958949